import View from './view';
import icon from '@plone/volto/icons/hero.svg';

const HPHeroBlock = {
  id: 'hp_hero',
  title: 'HP Hero',
  icon: icon,
  group: 'homepage',
  view: View
};

export default HPHeroBlock;
